export default {
    methods: {
        formatCardExpiry(card) {
            let output = '';

            if (card.exp_month < 10) {
                output = '0';
            }

            output += card.exp_month + ' / ' + card.exp_year;

            return output;
        },
    }
};
